import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  id: string;
}

interface Result {}

const options: ApiOptions = {
  method: 'delete',
  urlPath: '/migration/delete_item',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useDeleteMigrationItem = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useDeleteMigrationItemsLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useDeleteMigrationItem;
